/* jshint esversion: 6 */
import { filter, mergeMap } from 'rxjs/operators';
import api from 'app/redux/api.js';
import { LinkpageActions } from 'app/redux/actions.js';
import * as constants from 'app/redux/constants.js';

// api() hands the success callback the response body only, so the social id the
// reducer keys on has to be carried across from the request action.

export const fetchLinkpageSettingsEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.LINKPAGE_SETTINGS_LIST && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, null,
        (payload) => LinkpageActions.receiveLinkpageSettings(action.id, payload)))
);

export const updateLinkpageSettingsEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.LINKPAGE_SETTINGS_UPDATE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, action.post,
        (payload) => LinkpageActions.updatedLinkpageSettings(action.id, payload, action.post)))
);
